import React, { useEffect, useId, useState } from 'react';
import theme from './ReorderPopupBar.module.scss';
import { Button, PopupBar } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import { Event } from '@ygtechnologies/rubus-frontend-utilities';

export interface ReorderPopupBarProps {
    onAccept(): Promise<any>;
    onCancel(): void;
    open: boolean;
}

const onOpenGlobal = new Event<[string]>();

export const ReorderPopupBar: React.FC<ReorderPopupBarProps> = ({ onAccept, onCancel, open }) => {
    const [saving, setSaving] = useState(false);
    const id = useId();

    useEffect(() => {
        setSaving(false);

        const handler = (otherId: string) => {
            if (otherId !== id) {
                handleCancel();
            }
        };

        if (open) {
            onOpenGlobal.trigger(id);
        }

        onOpenGlobal.addHandler(handler);

        return () => {
            onOpenGlobal.removeHandler(handler);
        };
    }, [open]);

    const handleCancel = () => {
        onCancel();
    };

    const handleAccept = async () => {
        setSaving(true);
        try {
            await onAccept();
        } finally {
            setSaving(false);
        }
    };

    return (
        <PopupBar open={open} className={theme.reorderBar}>
            <Button variant="tertiary" icon={faTimes} onClick={handleCancel} disabled={saving}>
                <Trans>Revert</Trans>
            </Button>
            <Button variant="tertiary" icon={faCheck} onClick={handleAccept} loading={saving}>
                <Trans>Accept reorder</Trans>
            </Button>
        </PopupBar>
    );
};
